import { registerPlugin } from '@capacitor/core'

export interface GoogleAuthPlugin {
  signIn(additionalPermissions?: string[]): Promise<GoogleAuthResponse>
  signOut(): Promise<void>
}

export interface GoogleAuthResponse {
  givenName: string
  authentication: {
    idToken: string
  }
}

export const GoogleAuth = registerPlugin<GoogleAuthPlugin>('GoogleAuth')
